import { render, staticRenderFns } from "./keyboard-shortcut.vue?vue&type=template&id=8c069d68&scoped=true&"
import script from "./keyboard-shortcut.vue?vue&type=script&lang=js&"
export * from "./keyboard-shortcut.vue?vue&type=script&lang=js&"
import style0 from "./keyboard-shortcut.vue?vue&type=style&index=0&id=8c069d68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c069d68",
  null
  
)

export default component.exports